<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_sales" src="@/assets/images/icon_sales.png" alt=""/>销量查询</span>
      <el-main class="con">
        <el-form :disabled="loading">
          <el-form-item>
            <span style="color: red">*</span>
            <span style="margin-left: 5px">开始日期：</span>
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="beginDate"></el-date-picker>
            <span style="color: red;margin-left: 20px">*</span>
            <span style="margin-left: 5px">结束日期：</span>
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="endDate"></el-date-picker>
            <el-button class="but" type="success" size="small" @click="getTotalSales" :loading="loading">
              <span>查询</span>
            </el-button>
            <br>
            <el-radio size="mini" v-model="selectedType" label="1" border @change="typeChange">按客户</el-radio>
            <el-radio size="mini" v-model="selectedType" label="2" border @change="typeChange">按业务员</el-radio>
            <el-radio size="mini" v-model="selectedType" label="3" border @change="typeChange">按物料</el-radio>
            <el-radio size="mini" v-model="selectedType" label="4" border @change="typeChange">按客户和物料</el-radio>
            <el-radio size="mini" v-model="selectedType" label="5" border @change="typeChange">按客户与别名</el-radio>
            <el-radio size="mini" v-model="selectedType" label="6" border @change="typeChange">按业务员与物料</el-radio>
            <el-radio size="mini" v-model="selectedType" label="0" border @change="typeChange">流水</el-radio>
            <download-excel
              class = "export-excel-wrapper"
              :data = "saleDetailList"
              :fields = "json_fields"
              :name = "'销量查询_'+this.getDay(0)"
              style="display: inline;margin-left: 20px">
              <el-button type="primary" size="mini" :disabled="this.saleDetailList.length===0">导出明细</el-button>
            </download-excel>
            <br>
            <el-radio size="mini" v-model="present" label="0" border @change="changePresent">不含赠料</el-radio>
            <el-radio size="mini" v-model="present" label="1" border @change="typeChange">含赠料</el-radio>
            <el-checkbox style="margin-left: 10px" size="mini" v-model="isPresent" border @change="changeIsPresent">只查赠料</el-checkbox>
          </el-form-item>
        </el-form>
        <div class="total" v-if="totalSaleList.length > 0">
          <el-table size="mini" :data="totalSaleList" border show-summary v-loading="loading">
            <el-table-column label="业务员" v-if="selectedType === '1' || selectedType === '2' || selectedType === '4' || selectedType === '5' || selectedType === '6'">
              <template slot-scope="scope">
                <span>{{scope.row.YEWUYUAN}}</span>
              </template>
            </el-table-column>
            <el-table-column label="客户" v-if="selectedType === '1' || selectedType === '4' || selectedType === '5'">
              <template slot-scope="scope">
                <span>{{scope.row.KEHU}}</span>
              </template>
            </el-table-column>
            <el-table-column label="物料简称" v-if="selectedType === '3' || selectedType === '4' || selectedType === '6'">
              <template slot-scope="scope">
                <span>{{scope.row.JIANCHENG}}</span>
              </template>
            </el-table-column>
            <el-table-column label="别名" v-if="selectedType === '5'">
              <template slot-scope="scope">
                <span>{{scope.row.FALIAS === null ? '-' : scope.row.FALIAS}}</span>
              </template>
            </el-table-column>
            <el-table-column label="销量" prop="TOTALSHULIANG"></el-table-column>
            <el-table-column label="客户A值" prop="totalAdun"></el-table-column>
            <el-table-column label="标准吨" prop="totalBzd"></el-table-column>
            <el-table-column label="业务员A值" prop="totalYwyAdun"></el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="getSaleDetail(scope.row)" :loading="loading" :disabled="isShowReturn">查看明细</el-button>
                <el-button size="mini" type="warning" @click="returnTotal" v-if="isShowReturn" :disabled="loading">返回</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="list" v-if="saleDetailList.length > 0">
          <el-table size="mini" :data="saleDetailList" border show-summary max-height="450" v-loading="loading">
            <el-table-column label="业务员" prop="YEWUYUAN"></el-table-column>
            <el-table-column label="客户" prop="KEHU"></el-table-column>
            <el-table-column label="物料简称">
              <template slot-scope="scope">
                <span>{{scope.row.JIANCHENG+''}}</span>
              </template>
            </el-table-column>
            <el-table-column label="别名">
              <template slot-scope="scope">
                <span>{{scope.row.FALIAS === null ? '-' : scope.row.FALIAS}}</span>
              </template>
            </el-table-column>
            <el-table-column label="规格" prop="GUIGE"></el-table-column>
            <el-table-column label="销量" prop="SHULIANG"></el-table-column>
            <el-table-column label="客户A值" prop="AZHI"></el-table-column>
            <el-table-column label="标准吨" prop="BZD"></el-table-column>
            <el-table-column label="业务员A值" prop="ywyazhi"></el-table-column>
            <el-table-column label="业务日期">
              <template slot-scope="scope">
                <span>{{scope.row.FBIZDATE.substring(0,10)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
    </el-main>
  </el-container>
</template>

<script>
import {getDreporSales, getDreportType} from "../../../api/system/dreport";

export default {
name: "index",
  data(){
    return{
      currentUser:'',
      saleOrgName:'',
      personInfo:{},
      beginDate:this.getDay(-6),
      endDate:this.getDay(0),
      totalSaleList:[],
      totalSaleListTemp:[],
      saleDetailList:[],
      totalTon:0,
      totalATon:0,
      totalBTon:0,
      totalYATon:0,
      selectedType:'1',
      present:'0',
      isPresent:false,
      isShowReturn:false,
      loading:false,
      json_fields:{
        "业务员": "YEWUYUAN",    //常规字段
        "客户":"KEHU",
        "物料简称":"JIANCHENG",
        "别名":"FALIAS",
        "规格":"GUIGE",
        "销量":"SHULIANG",
        "客户A值":"AZHI",
        "标准吨":"BZD",
        "业务员A值":"ywyazhi",
        "业务日期":{
          field:"FBIZDATE",
          callback: value => {
            return value.substring(0,10)
          }
        }
      },
      // json_meta: [
      //   [
      //     {
      //       "key": "charset",
      //       "value": "utf-8"
      //     }
      //   ]
      // ]
    }
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    this.saleOrgName = sessionStorage.getItem("saleOrgName")
    this.personInfo = this.currentUser.person
    // console.log(this.personInfo)
  },
  methods:{
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    getDay(day) {
      //Date()返回当日的日期和时间。
      let days = new Date();
      //getTime()返回 1970 年 1 月 1 日至今的毫秒数。
      let getTimes = days.getTime() + 1000 * 60 * 60 * 24 * day;
      //setTime()以毫秒设置 Date 对象。
      days.setTime(getTimes);
      let year = days.getFullYear();
      let month = days.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let today = days.getDate();
      if (today < 10) {
        today = "0" + today;
      }
      return year + "-" + month + "-" + today;
    },
    getTotalSales(){
      if(this.beginDate === null){
        this.$modal.msg("请选择开始日期");
        return
      }
      if(this.endDate === null){
        this.$modal.msg("请选择结束日期");
        return
      }
      this.loading = true
      this.saleDetailList = []
      this.isShowReturn = false
      let param = {}
      param.bgDate = this.beginDate
      param.edDate = this.endDate
      param.salePersonID = this.personInfo.id
      param.pindex = '0'
      param.psize = '10000'
      param.getPresent = this.present
      param.isPresent = this.isPresent === false ? '0' : '1'
      param.gorupByType = this.selectedType
      // console.log(param)
      getDreportType(param).then(res => {
        if(res.code === 200){
          // console.log(res.data)
          if(!res.data.success){
            this.$modal.msg(res.data.message);
          }else{
            this.totalSaleList = res.data.data.resultData
            this.totalSaleListTemp = res.data.data.resultData
          }
          this.loading = false
          // this.totalTon = res.data.data.totalTun
          // this.totalATon = res.data.data.totalAdun
          // this.totalBTon = res.data.data.totalBZD
          // this.totalYATon = res.data.data.totalYwyAdun
        }
      }).catch(()=>{
        this.loading = false
      })
    },
    getSaleDetail(val){
      this.totalSaleList = []
      this.totalSaleList.push(val)
      this.isShowReturn = true
      let param = {}
      param.bgDate = this.beginDate
      param.edDate = this.endDate
      param.salePersonID = this.personInfo.id
      param.pindex = '0'
      param.psize = '10000'
      param.getPresent = this.present
      param.isPresent = this.isPresent === false ? '0' : '1'
      param.gorupByType = this.selectedType
      param.gorupByValue = this.switchValue(val)
      // console.log(param)
      this.loading = true
      getDreporSales(param).then(res => {
        if(res.code === 200){
          // console.log(res.data)
          if(!res.data.success){
            this.$modal.msg(res.data.message);
            this.loading = false
          }else {
            this.saleDetailList = res.data.data.result
            // console.log(this.saleDetailList)
            this.loading = false
          }
        }
      }).catch(()=>{
        this.loading = false
      })
    },
    switchValue(val){
      let text = ''
      switch (this.selectedType) {
        case '1':
          text = val.KEHUID;
          break;
        case '2':
          text = val.FID;
          break;
        case '3':
          text = val.BIANMA;
          break;
        case '4':
          text = val.KEHUID + ',' + val.BIANMA;
          break;
        case '5':
          text = val.KEHUID + ',' + val.FALIAS;
          break;
        case '6':
          text = val.FID + ',' + val.BIANMA;
          break;
      }
      return text;
    },
    changeIsPresent(){
      if(this.isPresent){
        this.present = '1'
      }
      this.getTotalSales()
    },
    changePresent(){
      if(this.present === '0'){
        this.isPresent = false
      }
      this.getTotalSales()
    },
    returnTotal(){
      this.totalSaleList = this.totalSaleListTemp
      this.saleDetailList = []
      this.isShowReturn = false
    },
    typeChange(){
      this.getTotalSales()
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 90vh;
  }
  .con{
    margin-top: 10px;
    border: 1px solid rgb(196, 196, 196);
  }
  .list{
    margin-top: 20px;
    /*height: 70vh;*/
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but1{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
  }
  .sp1{
    color: rgb(239, 51, 69);
    font-weight: bold;
    line-height: 20px;
  }
  .el-radio{
    margin: 0;
  }
  .but{
    margin-left: 20px;
    width: 100px;
    font-size: 14px;
    color: white;
    border: none;
    background: linear-gradient(180.00deg, rgba(239,50,68,1) 0%,rgba(246,88,104,1) 100%);
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_sales{
    width: 18px;
    height: 20px;
    display: flex;
    margin-top: 3px;
    margin-right: 10px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
  }
</style>
